module.exports = __webpack_public_path__ + "static/media/quote.352a61f8.svg";